import React from 'react';
import {
  Box,
  Container,
  SimpleGrid,
  Stack,
  Text,
  Link,
  Input,
  Button,
  VStack,
  HStack,
  Divider,
  useColorModeValue,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.600', 'gray.400');

  const ListHeader = ({ children }) => {
    return (
      <Text fontWeight="600" fontSize="lg" mb={4} color={useColorModeValue('gray.900', 'gray.100')}>
        {children}
      </Text>
    );
  };

  return (
    <Box bg={bgColor} borderTop="1px" borderColor={borderColor}>
      <Container maxW="container.xl" py={12}>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
          {/* Quick Links */}
          <Stack align="flex-start">
            <ListHeader>Quick Links</ListHeader>
            <Link as={RouterLink} to="/about" color={textColor} _hover={{ color: 'brand.500' }}>About Us</Link>
            <Link as={RouterLink} to="/blog" color={textColor} _hover={{ color: 'brand.500' }}>Blog</Link>
            <Link as={RouterLink} to="/contact" color={textColor} _hover={{ color: 'brand.500' }}>Contact</Link>
            <Link as={RouterLink} to="/funds" color={textColor} _hover={{ color: 'brand.500' }}>Mutual Funds</Link>
            <Link as={RouterLink} to="/register" color={textColor} _hover={{ color: 'brand.500' }}>Become an Agent</Link>
          </Stack>

          {/* Contact Info - Simplified */}
          <Stack align="flex-start">
            <ListHeader>Contact Us</ListHeader>
            <Text color={textColor}>
              Email: budgetbrilliance.in@gmail.com
            </Text>
          </Stack>

          {/* Newsletter */}
          <Stack align="flex-start">
            <ListHeader>Stay Updated</ListHeader>
            <Text color={textColor}>
              Subscribe to our newsletter for the latest updates and insights.
            </Text>
            <Stack direction="row" w="full">
              <Input
                placeholder="Enter your email"
                bg={useColorModeValue('gray.100', 'gray.700')}
                border={0}
                _focus={{
                  bg: useColorModeValue('gray.200', 'gray.600'),
                }}
              />
              <Button
                colorScheme="brand"
                flexShrink={0}
                px={6}
              >
                Subscribe
              </Button>
            </Stack>
          </Stack>
        </SimpleGrid>

        <Divider my={8} borderColor={borderColor} />

        {/* Bottom Section */}
        <HStack
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align="center"
          color={textColor}
          fontSize="sm"
          gap={4}
          w="full"
          flexWrap={{ base: 'wrap', md: 'nowrap' }}
        >
          <Text>
            © {new Date().getFullYear()} Budget Brilliance. All rights reserved
          </Text>
          <HStack spacing={8} justify={{ base: 'center', md: 'flex-end' }}>
            <Link as={RouterLink} to="/privacy-policy" color={textColor} _hover={{ color: 'brand.500' }}>
              Privacy Policy
            </Link>
            <Link as={RouterLink} to="/terms-of-service" color={textColor} _hover={{ color: 'brand.500' }}>
              Terms of Service
            </Link>
            <Link as={RouterLink} to="/cookie-policy" color={textColor} _hover={{ color: 'brand.500' }}>
              Cookie Policy
            </Link>
          </HStack>
        </HStack>
      </Container>
    </Box>
  );
};

export default Footer; 